import { Box, Tab, Tabs } from "@material-ui/core"
import type { ChangeEvent, ReactElement, ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { Body1 } from "../../atoms"

export interface ITabContainerProps {
  tabs: ReactNode[]
  centered?: boolean | undefined
  activeTab: number
  requiredLabel?: boolean
  onTabChange?: (activeTab: number) => void
}

export function TabContainer(props: ITabContainerProps): ReactElement {
  const { tabs, centered, activeTab, requiredLabel, onTabChange } = props
  const { t } = useTranslation("general")

  function onChange(_: ChangeEvent<{}>, newValue: number) {
    if (onTabChange) onTabChange(newValue)
  }

  return (
    <Box className="tab-container">
      <Tabs indicatorColor="primary" centered={centered} value={activeTab} onChange={onChange}>
        {tabs.map((tab: ReactNode, index: number) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: TODO fix in later PR
          <Tab key={index} label={tab} />
        ))}
      </Tabs>
      {requiredLabel && <Body1>({t("required").toLowerCase()})</Body1>}
    </Box>
  )
}
